import { TFunction } from 'i18next';
import { reportError } from '../components/ErrorTracker';

export interface ApiErrorFields {
  code: string;
  message: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  metadata: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  source: any;
}

export class ApiError {
  public code: string;
  public message: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public metadata: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public source: any;

  constructor({ code, message, metadata, source }: ApiErrorFields) {
    this.code = code;
    this.message = message;
    this.metadata = metadata;
    this.source = source;
  }

  public getUserMessage(t: TFunction): string {
    return t(`api:errors.${this.code}`);
  }

  public static fromAPI(error: unknown): ApiError {
    /*
    Check error response, expected format is:
    {
      code: INTERNAL_ERROR_NAME, (required, e.g USER_CAN_NOT_EDIT_ANOTHER_USER)
      message: "Nice description" (required)
      metadata: null || { ... (optional keys) }
    }
    */
    if (error && typeof error === 'object' && Object.prototype.hasOwnProperty.call(error, 'code')) {
      // expected format
      const { code, message, metadata } = error as ApiError;
      if (code === 'INTERNAL_ERROR') {
        // report internal server error
        reportError('API - INTERNAL_ERROR', error, 'critical');
      }
      return new ApiError({
        code,
        message,
        metadata,
        source: error,
      });
    }
    // unexpected erorr format
    return new ApiError({
      code: 'unexpected_error',
      message: 'Ha ocurrido un error inesperado',
      metadata: undefined,
      source: error,
    });
  }
}
